import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../../../redux/modules/actions';
import AddInventoryItem              from './AddInventoryItem';


const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView,
    statsTable:             state.statsTable,
    scoreCard:              state.scoreCard,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterPage: actions.enterPage,
        leavePage: actions.leavePage,
        fetchScoreCardDataIfNeeded:   actions.fetchScoreCardDataIfNeeded,
        fetchStatsTableDataIfNeeded:  actions.fetchStatsTableDataIfNeeded,
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddInventoryItem);


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/addInventoryItem/index.js